import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { imagesView_template } from "../components/templates/imagesView_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class images_view extends vnModule_knockoutJS {
    protected viewTemplate: imagesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string {
        return "images_view";
    }

    public buildContent(): Array<Element> {
        this.viewTemplate = new imagesView_template("view_template", this.viewModel, this);
        this.template = this.viewTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Images List");

        return [this.viewTemplate.build()];
    }

    public fillPage(): void {
        this.getData();
    }

    protected getData() {
        this.loadingIn(this.viewTemplate.builtTemplate);
        const idBrand = this.getVnAppZone().app.params.idBrand;
        const idImage = this.getVnAppZone().app.params.id;
        let usrReq_url: string = `/api/brand/${idBrand}/images/get/${idImage}/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.viewTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetData;
        this.XHRHdl.execute();
    }

    protected onGetData(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setUpForm(responseParsed.data);
            });
            obj.loadingOut(obj.viewTemplate.builtTemplate);
        };
    }

    public setUpForm(data): void {
        let primaryTag =
            data.image.details && data.image.details !== null && data.image.details.idPrimaryTag !== null
                ? data.image.details.primaryTag
                : null;

        this.viewTemplate.setId(data.image.id);
        this.viewTemplate.setName(data.image.name);
        this.viewTemplate.setDescription(data.image.description);
        this.viewTemplate.setCaption(data.image.caption);
        this.viewTemplate.setAltText(data.image.altText);
        this.viewTemplate.setUrl(data.image.url);
        this.viewTemplate.setSize(data.image.fileSize);
        this.viewTemplate.setSizeHuman(data.image.fileSize);
        this.viewTemplate.setHeight(data.image.height);
        this.viewTemplate.setWidth(data.image.width);
        this.viewTemplate.setRatio(data.image.ratio);
        this.viewTemplate.setIsAiEnhanced(data.image.isAiEnhanced);
        this.viewTemplate.setIsHdrAdjusted(data.image.isHdrAdjusted);
        this.viewTemplate.setMimeType(data.image.mimeType);
        this.viewTemplate.setDateCreated(data.image.dateCreated);
        this.viewTemplate.setDateUpdated(data.image.dateUpdated);
        this.viewTemplate.setIsEditShown(true);
        // set primary tag first.
        this.viewTemplate.setPrimaryTag(primaryTag);
        this.viewTemplate.setImageTags(data.image.imageTags);
        this.viewTemplate.setPermissions(data.permissions);
    }

    protected edit(id) {
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/images/edit/" + id);
    }

    protected goBack() {
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/images");
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/images_view.ts